import axios from 'axios';
import { Notification } from 'element-ui';
import { GetAuthToken } from 'rj-server-auth-token';
import Cookies from 'js-cookies';
import { getSign } from './requestEncryption';

let AxiosApi = axios.create();
// let querystring = require('querystring');
// 允许跨域请求发送cookie
AxiosApi.defaults.withCredentials = false;
AxiosApi.defaults.baseURL = `${window._env_.VUE_APP_CHANNEL_REQUEST_ADDRESS}`;
AxiosApi.interceptors.request.use(
  config => {
    config.headers['web-sign-server-auth'] = GetAuthToken({
      sysId: 'c0c73417cf58cb87e146a78f6e44ef44',
      accessKeySecret: '7B3A866D-7343-540C-30FD-0E71BE1B667B'
    });
    config.headers['sysId'] = 'c0c73417cf58cb87e146a78f6e44ef44';
    config.headers['timeOut'] = new Date().getTime();
    config.headers['sid_login'] = localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '');
    config.headers['union_session_ticket'] = localStorage.getItem('union_session_ticket');

    let timestamp = localStorage.getItem('timestamp');
    if (timestamp && timestamp + 600000 > new Date().getTime()) {
      timestamp = new Date().getTime();
      localStorage.setItem('timestamp', timestamp);
    } else {
      timestamp = new Date().getTime();
    }
    const sign = getSign(config, axios, timestamp);
    config.headers['sign'] = sign;
    config.headers['timestamp'] = timestamp;

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

// http响应拦截器
AxiosApi.interceptors.response.use(
  res => {
    const body = res.data;
    if (body.status !== '200') {
      if (body) {
        Notification.error({ message: body.err || body.msg });
      } else {
        Notification.error({ message: '链接服务器失败' });
      }
    }
    return res.data;
  },
  error => {
    if (error.message.includes('428')) {
      Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
      Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
      Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
      Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
      Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
      // 干掉切换的渠道
      Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
      window.localStorage.removeItem('union_session_ticket');
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `${window.location.origin}/toLoginPage`;
      } else {
        window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
      }
      // return Notification.warning({
      //   message: '登录验证失败或登录已失效，请重新登录'
      // });
    }
    Notification.error({
      message: '请求服务器失败'
    });
    return Promise.reject(error);
  }
);
export default AxiosApi;
